$shm_ba_post_card $mol_view
	table null
	post_row null
	highlight \
	text \
	sub /
		<= Title $mol_view
			sub <= title_content /
		<= Meta $mol_view
			sub <= meta_content /
		<= Tags $mol_view
			sub <= tags_content /
		<= Text $mol_view
			style *
				^
				maxHeight <= text_max_height \220px
				overflow \hidden
			sub <= text_content /
		<= Text_more $mol_button_minor
			title \Показать полностью
			enabled <= text_more_visible false
			click? <=> text_more? null
		<= Metrics $mol_view
			sub <= metrics /
	Date_link $mol_link
		uri <= url \
		external true
		sub /
			<= date_time
	Date_copy $shm_button_copy
		hint \Скопировать ссылку на пост
		text <= url \
	Source_link $mol_link
		uri <= source_url \
		external true
		sub /
			<= source_title
	Source_copy $shm_button_copy
		hint \Скопировать ссылку на источник
		text <= source_url \
	Author_link $mol_link
		uri <= author_url \
		external true
		sub /
			<= author_title
	Author_copy $shm_button_copy
		hint \Скопировать ссылку на автора
		text <= author_url \
	Metric* $mol_view
		sub /
			<= metric_title* \
	Tag* $mol_view
		sub /
			<= tag_label* \
	Title_text $mol_dimmer
		haystack <= title
		needle <= highlight
	Text_text $mol_dimmer
		haystack <= text
		needle <= highlight
